// Shared types for the H-1 求人原稿添削 (ad review) feature.
// Used by both the frontend (src) and Cloudflare Pages Functions (functions).

/** 出力モード:summary=経営者向け / detail=担当者向け */
export type AdReviewViewMode = 'summary' | 'detail';

/** 添削モード:diagnose=診断のみ / rewrite=改善版原稿も生成 */
export type AdReviewMode = 'diagnose' | 'rewrite';

/** 対応媒体。複数選択可(媒体別に軸3/軸9を判定)。 */
export type AdReviewMedia = 'gaten' | 'indeed' | 'engage' | 'kyujinbox' | 'sukedachi' | 'other';

export const AD_REVIEW_MEDIA_LABELS: Record<AdReviewMedia, string> = {
  gaten: 'gaten職',
  indeed: 'Indeed',
  engage: 'Engage',
  kyujinbox: '求人ボックス',
  sukedachi: '助太刀社員',
  other: 'その他',
};

/**
 * 添削リクエスト。
 * セキュリティ方針(security_policy.md §2):求人サイトで公開される前提の情報のみ。
 * 求職者の個人情報・クライアントの非公開情報は含めない。
 */
export interface AdReviewRequest {
  /** 求人原稿の全文テキスト(必須)。タイトル/本文/給与・待遇をまとめて、または個別に。 */
  draftTitle?: string;
  draftBody: string;
  salaryText?: string;
  /** 想定媒体(複数可)。 */
  media: AdReviewMedia[];
  /** 任意:クライアント情報(社名・地域・強み・変更可否)。非公開情報は入れない。 */
  clientInfo?: string;
  /** 任意:採用ターゲット像(軸11の判定基準)。 */
  targetPersona?: string;
  viewMode: AdReviewViewMode;
  mode: AdReviewMode;
}

export interface AdReviewResponse {
  /** Markdown 形式の添削結果。フロントで編集可能に表示する。 */
  result: string;
  /** 使用した Gemini モデル名(表示・検証用)。 */
  model: string;
}
